<template>
  <div class="initial-questionnaires">
    <div class="inner">
      <h2>Virtual ECOSYSTEM （植生遷移デモ版）へようこそ！</h2>
      <p>ここはサイエンスグルーヴが開発する生態系シミュレーションを簡易的に体験できる空間です。</p>
      <p>デモ版は、過去の開発版を参考として公開しているものになります。</p>
      <p>プレイ前に、簡単なアンケートにお答えください。</p>
      <p>※過去に回答したことがある方は「回答せずに続ける」からお進みください。</p>

      <form @submit="submit">
        <div class="inputgroup">
          <label>1. 所属</label>
          <input type="text" placeholder="企業名・学校名" v-model="company" required />
        </div>
        <div class="inputgroup">
          <label>2. 職業</label>
          <input type="text" placeholder="例: 「高校教師」「中学生」" v-model="job" required />
        </div>
        <div class="inputgroup">
          <label>3. 氏名（任意）</label>
          <input type="text" v-model="name" />
        </div>
        <div class="inputgroup">
          <label>4. メールアドレス（任意）</label>
          <p>サイエンスグルーヴからのお知らせメールを受け取っても良い方はメールアドレスをご記入ください。</p>
          <input type="text" v-model="email" />
        </div>
        <div class="buttons">
          <input type="submit" class="button" value="送信" />
          <button class="button cancel" @click="close">回答せずに続ける</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'GameIntroduction',
  data() {
    return {
      company: '',
      job: '',
      name: '',
      email: '',
    };
  },
  created() {
    this.$store.dispatch('stopGame');
  },
  methods: {
    submit(e) {
      e.preventDefault();

      const params = new URLSearchParams();
      params.append('company', this.company);
      params.append('job', this.job);
      params.append('name', this.name);
      params.append('email', this.email);
      params.append('send', true);

      Axios.post('static/mailform.php', params)
        .then(result => {
          alert('Thank you!');
          this.close();
        })
        .catch(e => {
          alert('送信中にエラーが発生しました(' + e.message + ')');
          console.error(e);
        });
    },
    close(e) {
      if (e) e.preventDefault();
      this.$emit('done');
    },
  },
};
</script>

<style scoped lang="scss">
.initial-questionnaires {
  z-index: 1000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  box-sizing: border-box;

  .inner {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 90%;
    max-height: 95%;
    padding: 1em 3em;
    text-align: left;
    background: #555;
    border-radius: 30px;
    font-size: 0.8rem;
    line-height: 1.6em;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    overflow: scroll;
  }

  h2 {
    text-align: center;
  }

  .inputgroup {
    margin-bottom: 12px;

    label {
      display: block;
      margin-bottom: 8px;
      font-weight: bold;
      font-size: 18px;
    }
    input[type='text'] {
      width: 100%;
      padding: 10px;
      font-size: 24px;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;

    .button {
      flex: 1;
      display: block;
      margin: 20px;
      padding: 20px;
      text-align: center;
      background: #0a5;
      color: #fff;
      border-radius: 20px;
      cursor: pointer;
      border: 0;
      -webkit-box-sizing: content-box;
      -webkit-appearance: button;
      appearance: button;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        opacity: 0.5;
      }
      &.cancel {
        background: #888;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/InitialQuestionnaires.vue